module.exports = __webpack_public_path__ + "static/media/4_Standing up on the inside_DE.9485271f.txt";